import { ArticleShow } from '@atreus/data';
import { Box, Prose, Stack } from '@qcx/ui';
import { CommentSection } from './CommentSection';
import { DownloadButton } from '../../components/DownloadButton';
import { EditorialCard } from '../../../editorials/components/EditorialCard';
import { HeadingInfo } from '../../components/HeadingInfo';
import { ListBullets } from '../../../../components/ListBullets';
import { MostReadNews } from '../../components/MostReadNews';
import { PageBellowTheFold } from '../../../../components/page/PageBellowTheFold';
import { PromoBanner } from './PromoBanner';
import { route } from '../../../../route';
import { safeRenderHtml } from '../../../../lib/safe-render-html.lib';
import { transformHtml } from '../../../../lib/transform-html.lib';

interface PageBelowTheFoldComponentProps extends ArticleShow {
  firstPart: string;
  secondPart: string;
}

export const PageBelowTheFoldComponent = ({
  article,
  mostAccessed,
  articles,
  relatedNews,
  editorials,
  mostRecent,
  firstPart,
  secondPart,
  banner
}: PageBelowTheFoldComponentProps) => (
  <PageBellowTheFold>
    {article.contestNotice && article.contestName && (
      <DownloadButton
        buttonLink={article.contestNotice}
        buttonText={article.contestName}
      />
    )}
    <Box css={{ d: 'flex', flexDir: 'column', gap: '$4', mb: '$4' }}>
      <Prose
        as="article"
        css={{
          '& p': {
            my: 0
          },
          '& .hs-cta-embed': {
            width: '100% !important',
            maxW: 500
          }
        }}
        dangerouslySetInnerHTML={{
          __html: safeRenderHtml(transformHtml(firstPart))
        }}
      />
      {banner?.bannerShow?.isBannerActive && (
        <PromoBanner
          buttonText={banner.bannerShow.buttonText}
          description={banner.bannerShow.description}
          imageUrl={banner.bannerShow.image.url}
          link={banner.bannerShow.link}
          title={banner.bannerShow.title}
        />
      )}
      <Prose
        as="article"
        css={{
          '& p': {
            my: 0
          },
          '& .hs-cta-embed': {
            width: '100% !important',
            maxW: 500
          }
        }}
        dangerouslySetInnerHTML={{
          __html: safeRenderHtml(transformHtml(secondPart))
        }}
      />
    </Box>

    <Box css={{ pt: '$12', pb: '$14' }}>
      <CommentSection />
    </Box>

    <Box css={{ d: 'flex', flexDir: 'column', gap: '$14' }}>
      {mostAccessed && mostAccessed.length > 0 && (
        <HeadingInfo link={route('news-index')} title={'Notícias mais lidas'}>
          <MostReadNews articles={mostAccessed} />
        </HeadingInfo>
      )}
      {articles && articles.length > 0 && (
        <HeadingInfo link={route('articles-index')} title={'Artigos'}>
          <ListBullets bullets={articles} />
        </HeadingInfo>
      )}
      {relatedNews && relatedNews.length > 0 && (
        <HeadingInfo link={route('news-index')} title={'Notícias relacionadas'}>
          <MostReadNews articles={relatedNews} />
        </HeadingInfo>
      )}
      {editorials.length > 0 && (
        <HeadingInfo
          isViewMore={editorials.length > 3}
          link={route('editorials-index')}
          title={'Editorias relacionadas'}
        >
          <Stack
            css={{
              pt: '$6',
              '@xs': { gap: '$8' },
              '@md': { gap: '$8' }
            }}
            flow={{
              '@initial': 'column'
            }}
          >
            {editorials.map(
              editorial =>
                editorial.name && (
                  <EditorialCard
                    key={editorial.slug}
                    css={{
                      border: 'none',
                      p: 0,
                      pl: 5,
                      pr: '$3',
                      gap: '$2',
                      '& > span': {
                        color: '$blue900',
                        fontSize: '$4'
                      },
                      '@lg': { h: 45 }
                    }}
                    editorial={editorial}
                  />
                )
            )}
          </Stack>
        </HeadingInfo>
      )}
      {mostRecent && mostRecent.length > 0 && (
        <HeadingInfo link={route('news-index')} title={'Últimas notícias'}>
          <MostReadNews articles={mostRecent} />
        </HeadingInfo>
      )}
    </Box>
  </PageBellowTheFold>
);
